import { render } from "./VideoPlayerControlsSettingsQuality.vue?vue&type=template&id=87b9709e"
import script from "./VideoPlayerControlsSettingsQuality.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsQuality.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__